import { Injectable } from '@angular/core';

/**
 * Configuration service for the FishProgressbar component.
 * You can inject this service, typically in your root component, and customize the values of its properties in
 * order to provide default values for all the progress bars used in the application.
 */

export class FishProgressbarConfig {
  max = 100;
  animated = false;
  striped = false;
  type: string;
  showValue: boolean = false;
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
